import { formatDateTime } from "Utils/formatDateTime";
import { MaskCPF } from "Utils/Masks";
import { ContainerResult } from "../styles";

export type Result = {
  cpf: string;
  full_name: string;
  id: number;
  partner_name: string;
  partner_send: boolean;
  status: string;
  updated_at: string;
  sent_to: string;
  requisition_code: string;
};

interface ResultStatusProps {
  data: Result[];
}

export const ResultStatus = ({ data }: ResultStatusProps) => {
  return (
    <ContainerResult>
      <div className="page-content-list">
        <table className="table-content small-separate details">
          <thead>
            <tr>
              <td className="text-saira">Paciente</td>
              <td className="text-saira">CPF</td>
              <td className="text-saira">Requisição</td>
              <td className="text-saira">Atualização</td>
              <td className="text-saira">Parceiro</td>
              <td className="text-saira">Status</td>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr>
                <td>{item.full_name || "N/A"}</td>
                <td>{item.cpf ? MaskCPF(item.cpf) : "N/A"}</td>
                <td>{item.requisition_code}</td>

                <td>
                  {formatDateTime(item.updated_at).date}{" "}
                  {formatDateTime(item.updated_at).time}
                </td>
                <td>{item.sent_to || "N/A"}</td>
                <td>{item.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ContainerResult>
  );
};
